import { render } from "./Reports.vue?vue&type=template&id=61ed354b&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=61ed354b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ed354b"],['__file',"src/pages/Reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61ed354b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61ed354b', __exports__)) {
    api.reload('61ed354b', __exports__)
  }
  
  module.hot.accept("./Reports.vue?vue&type=template&id=61ed354b&scoped=true", () => {
    api.rerender('61ed354b', render)
  })

}


export default __exports__